import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';
import { IIconBlok } from './icon.model';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-icon',
    imports: [MatIconModule, NgClass],
    templateUrl: './icon.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class]': 'getDisplayClasses()',
    },
})
export class IconComponent {
    private _tailwind = inject(TailwindService);
    block = input.required<IIconBlok>();

    getIconAlignClasses = computed<string[]>(() => {
        const block = this.block();
        return this._tailwind.getSpacingClasses({
            marginX: block.align,
            marginXTablet: block.alignTablet,
            marginXDesktop: block.alignDesktop,
        });
    });

    getIconClasses = computed<string[]>(() => {
        const block = this.block();
        return [
            ...this.getIconAlignClasses(),
            ...this._tailwind.getSpacingClasses(block),
            ...this._tailwind.getBackgroundColorClasses(block),
            ...this._tailwind.getBoxShadowClasses(block),
            ...this._tailwind.getBorderRadiusClasses(block),
        ];
    });

    getDisplayClasses = computed<string[]>(() => {
        return this._tailwind.getDisplayClasses(this.block());
    });
}
